<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">

          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">My Team Performance Reviews</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Performance Reviews</li>
                </ul>
              </div>
              
            </div>
          </div>
          <!-- /Page Header -->
                              <div class="row">
                                <div class="col-md-12">
                                   <div class="card">
                                    <div class="card-header">
                                      <div class="d-flex justify-content-between">
                                        <h4 class="card-title mb-0">Perfomance Reviews</h4>
                                        
                                      </div>
                                    </div>
                              <div class="card-body">
                              <!----Datatable-->
                                <div class="row">
                                    <div class="col-md-12">
                                    <div class="table-responsive">
                                    
                                  <v-data-table
                                    :headers="headers"
                                    :items="reviews"
                                    sort-by=""
                                    class="elevation-1"
                                  >
                                    <template v-slot:[`item.profile`]="{ item }">
                                      <h2 class="table-avatar blue-link">
                                        <router-link :to="{name: 'reviewDetail', params: {id: item.id}, query: {type: 1}}" class="avatar"><img alt=""
                                                            src="~@/assets/profiles/avatar-02.jpg" v-if="!item.employee.passportPhoto">
                                                            <img alt="" :src="media + item.employee.passportPhoto" width="38" v-if="item.employee.passportPhoto"
                                        /></router-link>
                                        <router-link :to="{name: 'reviewDetail', params: {id: item.id}, query: {type: 1}}">{{
                                            `${item.employee.firstName} ${item.employee.lastName}`
                                            }}</router-link>
                                        </h2>
                                    </template>
                                    <template v-slot:[`item.stat`]="{ item }">
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 0"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-purple"></i> New
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 1"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Manager Comment
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 2"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting HR Comment
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 3"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-primary"></i> Awaiting Mgt Comment
                                      </a>
                                      <a class="btn btn-white btn-sm btn-rounded" v-if="item.status == 5"
                                          aria-expanded="false">
                                              <i class="fa fa-dot-circle-o text-sucess"></i> Completed
                                      </a>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                
                                        <div class="dropdown dropdown-action">
                                        <a
                                            href="#"
                                            class="action-icon dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="false"
                                            ><i class="material-icons">more_vert</i></a
                                        >
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <router-link :to="{name: 'reviewDetail', params: {id: item.id}, query: {type: 1}}"
                                            class="dropdown-item"
                                            
                                            ><i class="fa fa-pencil m-r-5"></i> Details</router-link
                                            >
                                            
                                        </div>
                                        </div>
                                    </template>
                                    </v-data-table>
                                    </div>
                                    </div>
                                </div>
                                <!---/Datatable-->
                              </div>
                              </div>
                                </div>
                               
                              </div>
                              
                                
                           
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from '@/services/authenticationService';
import { performanceService } from '@/services/performanceService';
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
      return {
        dialogDelete: false,
        headers: [
          {
            text: 'Employee',
            align: 'start',
            value: 'profile',
          },
          { text: 'Year', value: 'year' },
          { text: 'Status', value: 'stat' },
          { text: '', value: 'actions', sortable: false },
        ],
        employeeId: this.$route.params.id,
        currentUser: authenticationService.currentUserValue,
        company: authenticationService.currentOfficeValue,
        reviews: [],
        submitted: false,
        loading: false,
        error: ""
    }
   },
  mounted() {
      this.getReviews()
        if ($('.datatable').length > 0) {
            $('.datatable').DataTable({
            "bFilter": false,
            });
        }
  },

  methods: {
    getReviews () {
      performanceService.getReviewsByManager(this.currentUser.employee.id)
          .then(
            model => { this.reviews = model
            console.log(model) },
            error => { error = error }
          )
    },
    onDelete () {
        performanceService.removeGoal(this.goal.id)
        .then(
            model => {
                this.getGoals();
                this.closeDelete()
            }
        )
    },
    openDelete(item) {
        this.goal = item
        this.dialogDelete = true
    },
    closeDelete() {
      this.dialogDelete = false;
      // this.clearModel();
    },
  },
  name: "addGoalActivity"
};
</script>
<style scoped>
.datelay {
    z-index: 100;
}

.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/review/managerReviews.vue